(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["offsetBanner"] && !window.DesignMode) return;
  try {
    


    jQuery(document).ready(function(){
      jQuery('.ob_image_container').slick({
         autoplay: true,
        autoplaySpeed: 2000
      });
    });
  
  

  } catch(e) { console.error(e); }
})();

})();
